import bespoke from 'bespoke'
import touch from 'bespoke-touch'
import keys from 'bespoke-keys'
import bullets from './bespoke-plugins/bullets'
import freeze from './bespoke-plugins/freeze'
import wheel from './bespoke-plugins/wheel'

function deck(selector) {
    return bespoke.from(selector, [
        freeze(),
        //touch('vertical'), 
        bullets('.step'), 
        keys('vertical'),
        wheel(),
    ]);
}

export default deck;